import "./ContentDetails.css"
import CardItem from "../CardItem/CardItem";
import { ContentStatus } from "../../Models/ContentStatus";

const ContentDetails = ({ thumbnailUrl, title, subtitle, description, onClick }) => {

    return (
        <div className="content-details-container" onClick={onClick} role='button' tabIndex={0}>
            <div className="content-details-image-container">
                <CardItem status={ContentStatus.ACTIVE} imageUrl={thumbnailUrl} />
                <div className="content-details-overlay-title">
                    <h1 className="content-details-card-title">{title}</h1>
                    {subtitle && <h2 className="content-details-card-subtitle">{subtitle}</h2>}
                </div>
            </div>
            <p className="content-details-card-description">{description}</p>
        </div>
    );
};

export default ContentDetails;